import styled from 'styled-components';

export const StyledJourneyModalFooter = styled.div`
  width: 100%;
  height: 86px;
  box-shadow: 0px -4px 10px rgb(0 0 0 / 10%);
  background-color: white;
  z-index: 9;
  position: sticky;
  top: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 2em;
  align-items: center;
`;

export const StyledJourneyModalContent = styled.div`
  background: white;
  height: ${(props) => (props.footer ? 'calc(100% - 86px)' : '100%')};
  width: 100%;
  display: flex;
`;

export const StyledJourneyModalInner = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  outline: none;
`;

export const StyledExit = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  svg {
    font-size: 0.7em;
  }
`;

export const StyledMainContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 2em;
`;

export const StyledJourneySideModalHeading = styled.div`
  width: 100%;
  margin-bottom: 2em;
`;

export const StyledHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5em;
  svg {
    margin-right: 0.5em;
  }
`;

export const StyledLogoTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
